// Lowest minimum patient age (years) for CXR AI triage per viewer mode. A firm can only raise it.
// Kept in sync with Constants.CxrTriageMinAge in augmento-backend and dicom-processor-service.
export const CXR_TRIAGE_MIN_AGE = {
  PURE_ANALYZER: 18,
  HYBRID_ANALYZER: 4,
  DETECT: 4,
};

export const CXR_TRIAGE_MAX_AGE = 120;

export const getCxrViewerMode = ({ cxrVersionViewer, showFindings, showProbability }) => {
  if (!cxrVersionViewer) {
    return "DETECT";
  }
  return showFindings || showProbability ? "HYBRID_ANALYZER" : "PURE_ANALYZER";
};

export const getCxrTriageModeMinAge = (values) => CXR_TRIAGE_MIN_AGE[getCxrViewerMode(values)];

// Empty is valid: the viewer mode minimum then applies at triage time.
export const isCxrTriageMinAgeValid = (values) => {
  const minAge = values.cxrTriageMinAge;
  if (minAge == null || minAge === "") {
    return true;
  }
  return Number.isInteger(minAge) && minAge >= getCxrTriageModeMinAge(values) && minAge <= CXR_TRIAGE_MAX_AGE;
};
